import React from "react";
import styled from "styled-components";
import { NavLink } from "react-router-dom";

export const NavigationWrapper = styled.div`
  background-color: #eee;
  display : flex;
  flex : 2; 
  /* 이 아래는 어드민 이랑 같이 공유되고 있어서 어드민일경우 아닐경우를 손봐야함. */
  flex-direction : ${props=>props.admin ? "column" : "row" } ;
  min-width : ${props=>props.admin ? "369px" : "1280px" } ;
  margin: 0 auto;
	justify-content: center;
`;

export const LinksWrapper = styled.div`
    display : flex;
     /* background : #f6f6f6; */
    /* padding : 30px; */
    margin : ${props=>props.admin ? "0" : "0 auto" } ;
    flex-direction : ${props=>props.admin ? "column" : "row" } ;
		width: 1320px;
		min-width: 1300px;
`;

export const MyLink = styled(({ isDefaultRoute, ...rest }) => (
  <NavLink {...rest} />
))`
  background-color: ${props =>
    props.isDefaultRoute === true ? "#8bc541" : "inherit"};
  &:active,
  &.active {
    background-color: #8bc541;
    transition : all 0.5s ease;
  }
  &:hover{
    background-color : #dae6cb;
    transition : all .1s ease;
  }
  padding: 20px;
`;
